<template>
    <div>
        <p>₱</p>
    </div>
</template>